var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.0001,
    cy: 6.99961,
    r: 6.4,
    fill: "#545454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00029 10.5996L7.00029 6.59961",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00029 3.39902C6.55847 3.39902 6.20029 3.7572 6.20029 4.19902C6.20029 4.64085 6.55846 4.99902 7.00029 4.99902C7.44212 4.99902 7.80029 4.64085 7.80029 4.19902C7.80029 3.7572 7.44212 3.39902 7.00029 3.39902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.def739785e92902b429dcff99b446730.svg";
export { ForwardRef as ReactComponent };